import '.bt{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.p{position:absolute;}.ssr-plugin'
import '.cv{top:0;}.ssr-plugin'
import '.cw{right:-4px;}.ssr-plugin'
import '.cx{width:1.5rem;}.ssr-plugin'
import '.cy{height:1.5rem;}.ssr-plugin'
import '.ag{border-radius:1.25rem;}.ssr-plugin'
import '.cz{background-color:var(--primary-red);}.ssr-plugin'
import '.b3{cursor:pointer;}.ssr-plugin'
import { Image } from '@app/components/core/image/Image'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashUndo } from '@fortawesome/pro-solid-svg-icons'

export const PreviewImage = ({
  src,
  onDelete,
  onCancelDelete,
}: {
  src: string
  onDelete?: () => void
  onCancelDelete?: () => void
}) => {
  const showDeleteButton = onDelete && !onCancelDelete
  const showCanceleDelete = onDelete && !!onCancelDelete
  return (
    <div className="bt a g c"
    >
      <Image
        onClick={onCancelDelete}
        src={src}
        style={{
          width: '5.625rem',
          height: '5.625rem',
          borderRadius: '1.25rem',
          objectFit: 'cover',
          objectPosition: 'center',
          aspectRatio: '1/1',
          flexShrink: 0,
          filter: showCanceleDelete ? 'brightness(50%)' : 'none',
        }}
      />
      {showDeleteButton && <RemoveImageIcon onClick={onDelete} />}
      {showCanceleDelete && (
        <FontAwesomeIcon
          onClick={onCancelDelete}
          icon={faTrashUndo}
          color="var(--shades-white)"
          fontSize={'3rem'}
          style={{ position: 'absolute' }}
        />
      )}
    </div>
  )
}

const RemoveImageIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="a g c p cv cw cx cy ag cz b3"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faXmark} color="var(--shades-white)" />
    </div>
  )
}
